import QueryActions from './QueryActions.js';

/**
 * @param {object} query
 * @param {object} query.api an api object
 * @param {string} query.type 
 * @param {string} query.mode
 * @param {string} query.queryable
 * @returns {function} 
 */
function getApiQueryable({
  api,
  type,
  mode,
  queryable
}) {
  // type is device, system, or project
  // we need to pass in the device, system or project
  let toReturn = api[type](queryable);

  // if its not the device, we need to hit device().events or device().history
  if (type !== 'device') {
    toReturn = toReturn.device;
  }
  // mode is events
  // we're events so we need to list because it has other actions
  toReturn = toReturn[mode]().list;

  // this should be a function to call with query opts
  return toReturn;
}
export default QueryActions.create({
  mode: 'events',
  getApiQueryable
});